export enum EImageSource {
  ORDER = 'order',
  GIFT_PACKAGING = 'giftbox',
  SMALL = 'small',
}
